import { Link } from "react-router-dom";

const ManifestoStrip = () => (
  <section className="bg-ink text-cream py-24 md:py-28">
    <div className="container mx-auto px-6 text-center max-w-3xl">
      <span className="text-[11px] tracking-[0.22em] uppercase text-cream/45 font-semibold">— Apie Laimės Dietą —</span>
      <p className="font-marquee text-3xl md:text-5xl font-light leading-[1.2] mt-6 mb-8">
        Tikroji laimė ateina ne iš to, ką turime, bet iš to,{" "}
        <span className="italic text-terracotta font-normal">kas esame.</span>
      </p>
      <p className="text-cream/55 text-base mb-8">Saviugdos platforma moterims. Nuo 2018 m.</p>
      <Link to="/apie" className="text-terracotta hover:text-cream transition-colors text-sm tracking-wide font-medium">
        Pilna istorija →
      </Link>
    </div>
  </section>
);

export default ManifestoStrip;
